import { faEdit, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Badge, Dropdown, Table } from "react-bootstrap";
import CustomToggle from "../toggle/CustomToggle";

interface IAdminSupportUserTable {
  users: any[];
  exams: { value: string; label: string }[];
  onEdit: (user: any) => void;
}

const AdminSupportUserTable = ({ users, exams, onEdit }: IAdminSupportUserTable) => {
  const examNameMap = Object.fromEntries(exams.map((e) => [e.value, e.label]));

  return (
    <Table striped hover className="xcn-text-12 mt-3">
      <thead>
        <tr>
          <th>Sr.No</th>
          <th><span className="fw-bold">Name</span></th>
          <th><span className="fw-bold">Email</span></th>
          <th><span className="fw-bold">Status</span></th>
          <th><span className="fw-bold">Exams</span></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {users && users.length > 0
          ? users.map((user: any, index: number) => (
            <tr key={user._id || index}>
              <td>{index + 1}</td>
              <td>{user.name || "N/A"}</td>
              <td>{user.email || "N/A"}</td>
              <td>
                {user.allowed
                  ? <Badge bg="success">Active</Badge>
                  : <Badge bg="danger">Blocked</Badge>}
              </td>
              <td>
                {user.examsAllowed && user.examsAllowed.length > 0
                  ? user.examsAllowed.map((examId: string) => (
                    <Badge bg="secondary" className="me-1" key={examId}>
                      {examNameMap[examId] || examId}
                    </Badge>
                  ))
                  : "—"}
              </td>
              <td>
                <Dropdown>
                  <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => onEdit(user)}>
                      <FontAwesomeIcon icon={faEdit} className="text-primary me-2" />
                      <span className="fw-bold">Edit</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))
          : <tr><td colSpan={6} className="text-center text-muted">No support users found</td></tr>}
      </tbody>
    </Table>
  );
};

export default AdminSupportUserTable;
